// extracted by mini-css-extract-plugin
export var fragment = "statsCard-module--fragment--d06eb";
export var imageSection = "statsCard-module--imageSection--d1f4d";